import { useEffect, useState } from "react";
import { Checkbox, ComboBox, DefaultButton, Dialog, DialogType, IComboBoxOption, IconButton, Label, PrimaryButton, Stack, TextField } from "@fluentui/react";
import styles from '../styles/pokemon.module.scss';
import { TTag } from "../constants/types";

export interface IEditTagsProps {
    defaultTags: string; //Getest:bool:1|Status:string:Goed|Compleet:string:Alleen game|Versie:string:EUR
}

const EditTags : React.FunctionComponent<IEditTagsProps> = (props : IEditTagsProps) => {
    const [tags, settags] = useState<TTag[]>([]);
    const [tagnamesCBOptions, settagnamesCBOptions] = useState<IComboBoxOption[]>([]);
    const tagtypeCBOptions : IComboBoxOption[] = [{key:"string",text:"text"},{key:"bool",text:"Ja/Nee"}];
    const [selectedTagName, setselectedTagName] = useState<string>();
    const [selectedTagType, setselectedTagType] = useState<string>();
    const [selectedTagValue, setselectedTagValue] = useState<string>();

    const [newTagName, setnewTagName] = useState<string>();
    const [newTagType, setnewTagType] = useState<string>();
    const [newTagValue, setnewTagValue] = useState<string>();

    const [newDefaultTags, setnewDefaultTags] = useState<string>();
    const [showSaveConfirm, setShowSaveConfirm] = useState<boolean>(false);

    const [showTags, setshowTags] = useState<boolean>(window.innerWidth > 950 ? true : false);

    useEffect(() => {
        let tags : TTag[] = [];
        let tagnamesCBOptions: IComboBoxOption[] = [];

        const tagsparts = props.defaultTags.split('|');
        tagsparts.forEach(tagspart => {
            const tagparts = tagspart.split(':');
            tags.push({name: tagparts[0], type: tagparts[1], defaultValue: tagparts[2]});
            tagnamesCBOptions.push({key:tagparts[0], text:tagparts[0]});
        });

        settagnamesCBOptions(tagnamesCBOptions);
        if (tags.length > 0) {
            setselectedTagName(tags[0].name);
            setselectedTagType(tags[0].type);
            setselectedTagValue(tags[0].defaultValue);
        }
        settags(tags);
    },[props.defaultTags]);

    function onComboBoxTagNameChange(e,o,i) {
        setselectedTagName(o.key);
        tags.forEach(tag => {
            if (tag.name === o.key) {
                setselectedTagType(tag.type);
                setselectedTagValue(tag.defaultValue);
            }
        });
    }

    function onComboBoxTagTypeChange(type:string) {
        setselectedTagType(type);
        let stv: string = null;
        let btags = tags;
        btags.forEach(tag => {
            if (tag.name === selectedTagName) {
                if (tag.type !== type) {
                    tag.type = type;
                
                    props.defaultTags.split('|').forEach(tagspart => {
                        const tagparts = tagspart.split(':');
                        if (tag.name === tagparts[0] && type === tagparts[1]) {
                            stv = tagparts[2];
                        }
                    });
                } 
            }
        });
        settags(btags);
        setselectedTagValue(stv);
    }

    function addTag() {
        let buffTags = tags;
        buffTags.push({name: newTagName, type: newTagType, defaultValue: newTagValue});

        let tagnamesCBOptions: IComboBoxOption[] = [];

        buffTags.forEach(tag => {
            tagnamesCBOptions.push({key:tag.name, text:tag.name});
        });
        settagnamesCBOptions(tagnamesCBOptions);

        if (buffTags.length > 0) {
            setselectedTagName(tags[tags.length-1].name);
            setselectedTagType(tags[tags.length-1].type);
            setselectedTagValue(tags[tags.length-1].defaultValue);
        }
        settags(buffTags);

        setnewTagName("");
        setnewTagType("");
        setnewTagValue("");
    }

    function canSave() : boolean { //Getest:bool:1|Status:string:Goed|Compleet:string:Alleen game|Versie:string:EUR
        let newDefaultTags : string = "";
        tags.forEach(tag => {
            if (newDefaultTags !== "") {
                newDefaultTags += "|";
            }
            newDefaultTags += `${tag.name}:${tag.type}:${tag.defaultValue}`;
        });
        
        if (newDefaultTags === props.defaultTags) {
            return false;
        } else {
            return true;
        }
    }

    function save() {
        setShowSaveConfirm(true);
    }

    function doSave(copy:boolean) {

    }

    return (
        <Stack horizontal style={{marginLeft:0, display: window.innerWidth > 950 ? "flex":"block"}}>
            <Dialog
                hidden={!showSaveConfirm}
                dialogContentProps={{ type: DialogType.normal }}
                onDismiss={() => { setShowSaveConfirm(false); }}
                modalProps={{ styles: { main: { maxHeight: "100%!important", width: 800, height: 800, maxWidth: "100%!important", backgroundColor: "transparent", boxShadow: "none", overflowY: "auto" } } }}
            >
                <Stack horizontalAlign='center' style={{backgroundColor:"white",padding:20}}>
                    <Label>Weet u zeker dat u wilt opslaan?</Label>
                    <br/>
                    <table>
                        <tr>
                            <td>
                                <DefaultButton autoFocus style={{margin:5, width:"100%"}} text="Niet opslaan" onClick={() => { setShowSaveConfirm(false); }} />
                            </td>
                            <td>

                            </td>
                        </tr>
                        <tr>
                            <td>
                                <PrimaryButton style={{margin:5, width:"100%"}} text="Tags updaten" onClick={() => { doSave(false); }} />
                            </td>
                            <td>
                                <Stack horizontal verticalAlign="center">
                                    <Label style={{marginLeft:5}}>De standaard tags worden beschikbaar bij het toevoegen van nieuwe producten.</Label>
                                </Stack>        
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <DefaultButton style={{margin:5, width:"100%", backgroundColor: '#f00', color:"white" }} text="Tags toevoegen" onClick={() => { doSave(true); }} />
                            </td>
                            <td>
                                <Stack horizontal verticalAlign="center">
                                    <Label style={{marginLeft:5}}>ALLE producten worden geupdate met de nieuwe tags met de standaard waarde. Bestaande tags met dezelfde naam worden niet geupdate. Verwijderde tags worden van ALLE producten verwijderd.</Label>
                                </Stack>            
                            </td>
                        </tr>
                    </table>
                </Stack>
            </Dialog>
            <Stack style={{height:"100%", margin:5, border:"1px solid blue", padding:5}}>
                <Stack horizontal onClick={() => {setshowTags(!showTags)}} verticalAlign='center' >
                    <IconButton iconProps={{iconName: showTags ? 'Hide' : "View"}} />
                    &nbsp;
                    <Label style={{fontWeight:"bold", cursor:"pointer"}}>Standaard tags</Label>
                </Stack>
                {showTags && <Stack horizontalAlign='start'>
                                <ComboBox label={"Titel"} options={tagnamesCBOptions} selectedKey={selectedTagName} onChange={onComboBoxTagNameChange} />
                                <ComboBox label={"Type"} options={tagtypeCBOptions} selectedKey={selectedTagType} onChange={(e,o,i) => { onComboBoxTagTypeChange(o.key.toString()); }} />
                                <Stack horizontal verticalAlign="end">
                                    {selectedTagType === "string" ? <TextField label={"Standaard waarde"} value={selectedTagValue} onChange={(e,v) => {setselectedTagValue(v);}} />
                                                                : <Stack>
                                                                        <Label>Standaard waarde</Label>
                                                                        <Checkbox checked={selectedTagValue === "1" ? true : false} 
                                                                                label={selectedTagValue === "1" ? "Ja" : "Nee"} 
                                                                                onChange={(e,c) => { setselectedTagValue(c?"1":"0");}} />
                                                                    </Stack>}
                                    <PrimaryButton disabled={!canSave()} text="Opslaan" style={{marginLeft:10}} onClick={save} />
                                </Stack>
                            </Stack>}
            </Stack>
            <Stack style={{height:"100%", margin:5, border:"1px solid blue", padding: 5}} >
                <Stack horizontal onClick={() => {setshowTags(!showTags)}} verticalAlign='center' >
                    <IconButton iconProps={{iconName: showTags ? 'Hide' : "View"}} />
                    &nbsp;
                    <Label style={{fontWeight:"bold", cursor:"pointer"}}>Nieuwe standaard tag</Label>
                </Stack>
                {showTags && <Stack horizontalAlign='start'>
                                <TextField label={"Titel"} value={newTagName} style={{width:"100%"}} onChange={(e,v) => {setnewTagName(v);}}/>
                                <ComboBox label={"Type"} style={{width:"100%"}} options={tagtypeCBOptions} selectedKey={newTagType} onChange={(e,o,i) => { setnewTagType(o.key.toString());}} />
                                <Stack horizontal verticalAlign="end">
                                    {newTagType === "string" ? <TextField label={"Standaard waarde"} value={newTagValue} onChange={(e,v) => {setnewTagValue(v);}} />
                                                            : <Stack>
                                                                    <Label>Standaard waarde</Label>
                                                                    <Checkbox checked={newTagValue === "1" ? true : false} 
                                                                            label={newTagValue === "1" ? "Ja" : "Nee"} 
                                                                            onChange={(e,c) => { setnewTagValue(c?"1":"0");}} />
                                                            </Stack>}
                                    <PrimaryButton disabled={newTagName && newTagType ? false : true} text="Toevoegen" style={{marginLeft:10}} onClick={addTag}/>
                                </Stack>
                            </Stack>}
            </Stack>
        </Stack>
    );
}

export default EditTags;